import React,{useState} from 'react'
import styles from '../checkout/etcomments.module.scss'
import { useRouter } from 'next/router'
import endpoints from '../../../utility/endpoints';
import axios from 'axios';
import { IoIosArrowRoundForward, IoIosArrowRoundBack } from "react-icons/io"
function ETComments({onNext, onPrevious }) {
    const router = useRouter();
    const [commentText, setCommentText] = useState('');
    const [commentType, setCommentType] = useState('');
    const [submitForm, setSubmitForm] = React.useState(false);	
    const [selectedButtonType, setSelectedButtonType] = useState('');
    const handleButtonClick = (buttonType) => {
        setCommentType(buttonType);
        setSelectedButtonType(buttonType); // Set the selected button type
      };
    const onFromSubmit = async () => {

        let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      {/*  if (!commentText || !commentType) {	
          setSubmitForm(true);	
        }	
        else{*/}
              let auth = await JSON.parse(localStorage.getItem("auth")).data;
              axios({
                method: "POST",
                url: `${endpoints.baseUrl}/twin/createCartFormDataEntry`,
                headers: {
                  Authorization: `${auth.accessToken}|${auth.email}`,
                },
                data: {
                 "employeeTwinID":"",
                  "commentText" : commentText,
                  "commentType" : commentType,
                  "status":1
                },
              }).then((resp) => {
                if (resp.data.code == 403) {
                 // setLoading(false)
                 
                } 
                else if (resp.data.code == 200  || resp.data.code == 201) {
                
                    
                       router.push('/ETthankyou');
                      
                    
                      
                  
                } 
                else if (resp.data.code == 400) {
                
                }
              });
            
          //}
      
      };
    return (
        <div className={styles.etcommtcontainer}>
            <div className={styles.etcommentcontent}>
                <p className={styles.etcommentheading}>Comments</p>
                <div className={styles.etcommtbtncontent}>
                <button
            className={`${styles.etcmtbtn} ${selectedButtonType === 'New Skill' && styles.selectedButton}`}
            onClick={() => handleButtonClick('New Skill')}
          >
            New Skill
          </button>
          <button
            className={`${styles.etcmtbtn} ${selectedButtonType === 'Feedback' && styles.selectedButton}`}
            onClick={() => handleButtonClick('Feedback')}
          >
            Feedback
          </button>
          <button
            className={`${styles.etcmtbtn} ${selectedButtonType === 'Queries' && styles.selectedButton}`}
            onClick={() => handleButtonClick('Queries')}
          >
            Queries
          </button>
          <button
            className={`${styles.etcmtbtn} ${selectedButtonType === 'Others' && styles.selectedButton}`}
            onClick={() => handleButtonClick('Others')}
          >
            Others
          </button>
                </div>
                <div className={styles.et_commt_area_div}>
                    <textarea className={styles.et_commt_area} placeholder='Enter Comments'
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    name="commentText"></textarea>
                </div>
                {/* <div className={styles.et_commt_btn_content}>
                    <button className={styles.et_commt_btn}  onClick={onFromSubmit} >
                        Check out
                    </button>
                </div> */}
                <div className={styles.et_commt_btn_content}>
                    <button className={styles.et_commt_btn} onClick={onPrevious}>
                        <IoIosArrowRoundBack className={styles.et_arrow_btn} />Previous
                    </button>
                    <button className={styles.et_commt_btn} onClick={onFromSubmit} >
                        CHECK OUT <IoIosArrowRoundForward className={styles.et_arrow_btn} />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ETComments;
